var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.xs)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$store.commit('account/HIDE_AUTH_DIALOG')}}},[_c('v-icon',[_vm._v("mdi-close")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }